// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddGLAccountMutation($input: AddGLAccountInput!) {
    addGLAccount(input: $input) {
      glAccountEdge {
        node {
          id
          accountNumber
          name
          description
          accountType
          normalBalance
          balance
          isActive
          isSystem
          parentAccount {
            id
            name
          }
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'PaginatedGLAccountsContainer_glAccounts',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'glAccountEdge',
        },
      ],
    });
  },
};
